import { FhirArtefatoType } from '@/features/enterprise/models/types';
import BoxProcedimento from '@/features/recursos/procedimentos/components/BoxProcedimento';
import { groupBy } from '@/utils/collections';
import React from 'react';
import CategoriaArtefato from '../../CategoriaArtefato';
import { Content, Wrapper } from './styles';

interface ExamesProps {
  procedimentos: FhirArtefatoType[];
}

const ListaProcedimentosDefault: React.FC<ExamesProps> = ({
  procedimentos,
}) => {
  const procedimentosHasCategorias = React.useMemo(() => {
    return (
      procedimentos.filter(procedimento => !!procedimento.categoria).length > 0
    );
  }, [procedimentos]);

  const CategoriaContent = React.useMemo(() => {
    const groupedArtefatos = groupBy(
      procedimentos,
      option => option.categoria || 'Outros',
    );

    return Object.entries(groupedArtefatos).map(([key, value]) => (
      <CategoriaArtefato
        key={key}
        name={key}
        solicitacao_obrigatoria={value.some(
          procedimento => !!procedimento.solicitacao_obrigatoria,
        )}
        artefatos={value.map(procedimento => (
          <BoxProcedimento
            key={procedimento.id.toString()}
            procedimento={procedimento.pedido}
            solicitacao_obrigatoria={procedimento.solicitacao_obrigatoria}
            solicitacao_obrigatoria_motivo={
              procedimento.solicitacao_obrigatoria_motivo
            }
          />
        ))}
      />
    ));
  }, [procedimentos]);
  return (
    <Wrapper>
      <Content>
        {procedimentosHasCategorias ? (
          <>{CategoriaContent}</>
        ) : (
          <>
            {procedimentos.map(procedimento => (
              <BoxProcedimento
                key={procedimento.id.toString()}
                procedimento={procedimento.pedido}
                solicitacao_obrigatoria={procedimento.solicitacao_obrigatoria}
                solicitacao_obrigatoria_motivo={
                  procedimento.solicitacao_obrigatoria_motivo
                }
              />
            ))}
          </>
        )}
      </Content>
    </Wrapper>
  );
};

export default ListaProcedimentosDefault;
